import jsCookie from 'js-cookie';

const jsCookie_ = jsCookie;

export default {
	data() {
		return {
			jsCookie: jsCookie_
		}
	}
}